import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import CustomWebsiteSection from "./components/CustomWebsiteSection";
import ModuleLibrarySection from "./components/ModuleLibrarySection";
import BrandIdentitySection from "./components/BrandIdentitySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <CustomWebsiteSection />
      <ModuleLibrarySection />
      <BrandIdentitySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
